import React from "react";

export default () => <div>Types (@TODO: Migrate types page)</div>;
